import EventEmitter from './event-emitter';
type TimerEvents = {tick: []};
class Timer extends EventEmitter<TimerEvents> {
  private animationFrameId: number | null = null;
  private isRunning = false;
  start() {
    if (this.isRunning) return;
    this.isRunning = true;
    const tick = () => {
      if (!this.isRunning) return;
      this.emit('tick');
      this.animationFrameId = requestAnimationFrame(tick);
    };
    tick();
  }
  stop() {
    this.isRunning = false;
    if (this.animationFrameId !== null) {
      cancelAnimationFrame(this.animationFrameId);
      this.animationFrameId = null;
    }
  }
  destroy() {
    this.stop();
  }
}
export default Timer;
